import React from 'react';
import { Navigation } from './components/Navigation';
import { Hero } from './components/Hero';
import { StatsBand } from './components/StatsBand';
import { OriginStory } from './components/OriginStory';
import { MarketTiming } from './components/MarketTiming';
import { TheRole } from './components/TheRole';
import { Compensation } from './components/Compensation';
import { WhoThrives } from './components/WhoThrives';
import { InterviewProcess } from './components/InterviewProcess';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-screen bg-white" data-id="element-0">
      <Navigation data-id="element-1" />
      <Hero data-id="element-2" />
      <StatsBand data-id="element-3" />
      <OriginStory data-id="element-4" />
      <MarketTiming data-id="element-5" />
      <TheRole data-id="element-6" />
      <Compensation data-id="element-7" />
      <WhoThrives data-id="element-8" />
      <InterviewProcess data-id="element-9" />
      <FinalCTA data-id="element-10" />
      <Footer data-id="element-11" />
    </div>;
}